import React from 'react';
import { getReadableTextColor } from '../../utils';

const Label = ({ children }) => <span className="text-base font-medium text-foreground">{children}</span>;

/**
 * The shipper's logo, background color, and how they look together as a banner. Read only.
 * @param {{ logo: string | null, color: string | null, name: string }} props
 */
const CompanyBranding = ({ logo, color, name }) => (
    <div className="flex min-w-0 flex-col gap-3">
        <Label>Logo:</Label>
        {logo ? (
            <img src={logo} alt={`${name} logo`} className="max-h-12 max-w-xs self-start object-contain" />
        ) : (
            <span className="text-muted">No logo</span>
        )}
        <Label>Background:</Label>
        {color ? (
            <span
                className="self-start rounded-md px-3 py-2 text-lg font-bold"
                style={{ backgroundColor: color, color: getReadableTextColor(color) }}
            >
                {color.toUpperCase()}
            </span>
        ) : (
            <span className="text-muted">No background color</span>
        )}
        <Label>Banner Preview:</Label>
        <div
            className="flex h-20 w-full max-w-[640px] items-center justify-center rounded-md border border-border"
            style={{ backgroundColor: color || undefined }}
        >
            {logo ? (
                <img src={logo} alt="" className="max-h-12 max-w-[60%] object-contain" />
            ) : (
                <span className="text-muted">No logo to preview</span>
            )}
        </div>
    </div>
);

export default CompanyBranding;
